import { useEffect } from 'react';
import { getSiteUrl, SITE_NAME, FAVICON_URL } from '@/lib/seo';

const SCRIPT_ID = 'seo-jsonld';

export default function useJsonLd(data: object | object[] | null | undefined) {
  const serialized = data ? JSON.stringify(data) : null;

  useEffect(() => {
    let el = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;

    if (!serialized) {
      if (el) el.remove();
      return;
    }

    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = SCRIPT_ID;
      document.head.appendChild(el);
    }

    el.textContent = serialized;
  }, [serialized]);
}

export function websiteJsonLd(): object[] {
  const url = getSiteUrl();

  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: SITE_NAME,
      url,
      inLanguage: 'en',
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: SITE_NAME,
      url,
    },
  ];
}

export function articleJsonLd(opts: {
  path: string;
  title: string;
  description?: string;
  image?: string;
}): object {
  const path = opts.path.startsWith('/') ? opts.path : `/${opts.path}`;
  const url = `${getSiteUrl()}${path}`;

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: opts.title,
    description: opts.description,
    image: opts.image,
    url,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    author: {
      '@type': 'Organization',
      name: SITE_NAME,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
    },
  };
}